import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import { ValidateOptions, ValidationErrorInfo } from '@lib/interfaces';

export interface ValidatorMaxLengthOptions extends ValidateOptions {
  max: number;
}
/**
 *  桁数チェックValidator
 *
 * @param {ValidatorMaxLengthOptions} option
 * @returns {ValidatorFn}
 */
export function maxLengthValidator(option: ValidatorMaxLengthOptions): ValidatorFn {
  // チェックエラー時の戻り値定義
  const validationError = (defMsgId: string) => {
    return {
      'validate-length': {
        errorMsgId: option.errorMsgId || defMsgId,
        params: option.params,
      },
    };
  };

  return (control: AbstractControl): { [key: string]: ValidationErrorInfo } | null => {
    if (!control.value) {
      return null;
    }
    const dataLength = control.value.length;
    if (option.max < dataLength) {
      return validationError('E0013');
    }
    return null;
  };
}

export interface ValidatorFullNameMaxLengthOptions extends ValidateOptions {
  max: number;
  firstName: string;
  lastName: string;
}
/**
 *  桁数チェックValidator
 *
 * @param {ValidatorFullNameMaxLengthOptions} option
 */
export function fullNameMaxLengthValidator(option: ValidatorFullNameMaxLengthOptions) {
  // チェックエラー時の戻り値定義
  const validationError = (defMsgId: string) => {
    return {
      'validate-length': {
        errorMsgId: option.errorMsgId || defMsgId,
        params: option.params,
      },
    };
  };

  return (form: FormGroup): { [key: string]: ValidationErrorInfo } | null => {
    const varFirstName = form.controls[option.firstName].value ?? '';
    const varLastName = form.controls[option.lastName].value ?? '';
    if (!varFirstName || !varLastName) {
      return null;
    }

    if (varFirstName.length > 55 || varLastName.length > 55) {
      return null;
    }
    const dataLength = varFirstName.length + varLastName.length;
    if (option.max < dataLength) {
      return validationError(option.errorMsgId ?? 'E0406');
    }
    return null;
  };
}
